import { render, staticRenderFns } from "./BusDataSyncDocLogList.vue?vue&type=template&id=20f811d0&scoped=true&"
import script from "./BusDataSyncDocLogList.vue?vue&type=script&lang=js&"
export * from "./BusDataSyncDocLogList.vue?vue&type=script&lang=js&"
import style0 from "./BusDataSyncDocLogList.vue?vue&type=style&index=0&id=20f811d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f811d0",
  null
  
)

export default component.exports